import { useEffect, useMemo, useRef, useState } from "react";
import { MeetingProvider, useMeeting, useParticipant} from "@videosdk.live/react-sdk";
import { authToken, createMeeting } from "../page_components/videocall/API";
import ReactPlayer from "react-player";
import PreCallSetup from "./TestPreCallSetup";

function JoinScreen({ getMeetingAndToken }) {
  const [meetingId, setMeetingId] = useState(null);
  const onClick = async () => {
    await getMeetingAndToken(meetingId);
  };
  return (
    <div>      
      <input
        type="text"
        placeholder="Enter Meeting Id"
        onChange={(e) => {
          setMeetingId(e.target.value);
        }}
      />
      <button onClick={onClick}>Join</button>
      {" or "}
      <button onClick={onClick}>Create Meeting</button>
    </div>
  );
}
function ParticipantView(props) {
  const micRef = useRef(null);
  const { webcamStream, micStream, webcamOn, micOn, isLocal, displayName } =
    useParticipant(props.participantId);

  const videoStream = useMemo(() => {
    if (webcamOn && webcamStream) {
      const mediaStream = new MediaStream();
      mediaStream.addTrack(webcamStream.track);
      return mediaStream;
    }
  }, [webcamStream, webcamOn]);

  useEffect(() => {
    if (micRef.current) {
      if (micOn && micStream) {
        const mediaStream = new MediaStream();
        mediaStream.addTrack(micStream.track);

        micRef.current.srcObject = mediaStream;
        micRef.current
          .play()
          .catch((error) =>
            console.error("videoElem.current.play() failed", error)
          );
      } else {
        micRef.current.srcObject = null;
      }
    }
  }, [micStream, micOn]);

  return (
    <div>
      <p>
        Participant: {displayName} | Webcam: {webcamOn ? "ON" : "OFF"} | Mic:{" "}
        {micOn ? "ON" : "OFF"}
      </p>
      <audio ref={micRef} autoPlay playsInline muted={isLocal} />
      {webcamOn && (
        <ReactPlayer
          //
          playsinline // extremely crucial prop
          pip={false}
          light={false}
          controls={false}
          muted={true}
          playing={true}
          //
          url={videoStream}
          //
          height={"300px"}
          width={"300px"}
          onError={(err) => {
            console.log(err, "participant video error");
          }}
        />
      )}
    </div>
  );
}

function Controls() {
  const { leave, toggleMic, toggleWebcam } = useMeeting();
  return (
    <div>
      <button onClick={() => leave()}>Leave</button>
      <button onClick={() => toggleMic()}>toggleMic</button>
      <button onClick={() => toggleWebcam()}>toggleWebcam</button>
    </div>
  );
}

function MeetingView(props) {
  const [joined, setJoined] = useState(null);
  //Get the method which will be used to join the meeting.
  //We will also get the participants list to display all participants
  const { join, participants } = useMeeting({
    //callback for when meeting is joined successfully
    onMeetingJoined: () => {
      setJoined("JOINED");
    },
    //callback for when meeting is left
    onMeetingLeft: () => {
      props.onMeetingLeave();
    },
  });
  const joinMeeting = () => {
    setJoined("JOINING");
    join();
  };

  return (
    <div className="container">
      <h3>Meeting Id: {props.meetingId}</h3>
      {joined && joined === "JOINED" ? (
        <div>
          <Controls />
          {/* //For rendering all the participants in the meeting */}
          {[...participants.keys()].map((participantId) => (
            <ParticipantView
              participantId={participantId}
              key={participantId}
            />
          ))}
        </div>
      ) : joined && joined === "JOINING" ? (
        <p>Joining the meeting...</p>
      ) : (
        <button onClick={joinMeeting}>Join</button>
      )}
    </div>
  );
}

function TestFinalVideoCall() {
  const [meetingId, setMeetingId] = useState(null);
  const [meetingConfig, setMeetingConfig] = useState(null);
  const [showMeeting, setShowMeeting] = useState(false)

  const getMeetingAndToken = async (id) => {
    const gen = id == null
      ? await createMeeting({ token: authToken })
      : id;
    setMeetingId(gen);

    // Immediately join with current pre-call settings
    setMeetingConfig({
      micEnabled: meetingConfig?.micEnabled,
      webcamEnabled: meetingConfig?.webcamEnabled,
      microphoneId: meetingConfig?.microphoneId,
      webcamId: meetingConfig?.webcamId,
    });
  };

  return authToken && meetingId && meetingConfig && showMeeting ? (
    <MeetingProvider
      config={{
        meetingId,
        ...meetingConfig,
        name: "Jomar",
      }}
      token={authToken}
    >
      <MeetingView meetingId={meetingId} onMeetingLeave={() => { setMeetingId(null); setMeetingConfig(null); }} />
    </MeetingProvider>
  ) : (
    <PreCallSetup
      meetingId={meetingId}
      getMeetingAndToken={getMeetingAndToken}
      onStartMeeting={(cfg) => {
        setMeetingConfig(cfg);
        setShowMeeting(true);
      }}
    />
  );
}

export default TestFinalVideoCall;